import type { LpConsumable } from "../../../domain/ndt/lp-consumable.js";
import type { LpConsumableRepository } from "../../../repositories/operational-repositories.js";

const STORAGE_KEY = "lp_consumables";

export class InMemoryLpConsumableRepository implements LpConsumableRepository {
  private items = new Map<string, LpConsumable>();

  constructor() {
    this.loadFromStorage();
  }

  private loadFromStorage() {
    try {
      if (typeof localStorage !== "undefined") {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
          const parsed: LpConsumable[] = JSON.parse(stored);
          for (const item of parsed) this.items.set(item.id, item);
        }
      }
    } catch (e) {
      console.warn("Failed to load LP consumables from storage:", e);
    }
  }

  private persistStorage() {
    try {
      if (typeof localStorage !== "undefined") {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(this.items.values())));
      }
    } catch (e) {
      console.warn("Failed to persist LP consumables to storage:", e);
    }
  }

  async findById(id: string): Promise<LpConsumable | null> {
    this.loadFromStorage();
    return this.items.get(id) || null;
  }

  async listAll(): Promise<readonly LpConsumable[]> {
    this.loadFromStorage();
    return Array.from(this.items.values());
  }

  async save(item: LpConsumable): Promise<void> {
    this.items.set(item.id, { ...item });
    this.persistStorage();
  }

  async delete(id: string): Promise<void> {
    this.items.delete(id);
    this.persistStorage();
  }
}
